export const DEFAULT_MESSAGE = 'Request error'

const capitalizeFirstLetter = (s) => {
  if (typeof s !== 'string') return ''

  return `${s.charAt(0).toUpperCase()}${s.slice(1)}`
}

export const extractMessage = (error) => {
  if (!error || error.status === 500) {
    return DEFAULT_MESSAGE
  }

  if (error.status === 422 && error.attributes) {
    const messages = Object.values(error.attributes)
    return messages.length === 1 ? capitalizeFirstLetter(messages[0]) : messages.map(capitalizeFirstLetter).join(', ')
  }

  return typeof error.message === 'string' && error.message.trim().length > 0 ? capitalizeFirstLetter(error.message) : DEFAULT_MESSAGE
}

export const extractGraphQLErrors = (err) => {
  if (err.networkError) return [{ message: err.networkError.message }]

  const errors = err.graphQLErrors
  if (!errors?.length) return []

  return errors.map(({ message, extensions }) => {
    const { response = {} } = extensions
    const { type, ...restResponse } = response

    if (restResponse) {
      delete restResponse.message
      delete restResponse.status
    }
    return {
      message: message || extensions.message,
      status: extensions.code,
      ...extensions.attributes ? { attributes: extensions.attributes } : {},
      ...type ? { type } : {},
      data: restResponse,
    } })
}

export const extractGraphQLErrorMessage = (graphQlError) => {
  const errors = extractGraphQLErrors(graphQlError)
  return extractMessage(errors[0])
}

export default {}
